import t from './actionTypes'
import confirmTypes from 'helpers/enums/confirmTypes'
import { localize } from 'helpers/translator'

const binderActions = {
	initializeBinders() {
		return {
			type: t.BINDERS_INITIALIZE,
		}
	},

	getBinders() {
		return {
			type: t.BINDERS_GET_ALL,
		}
	},

	getLessons() {
		return {
			type: t.BINDERS_GET_BINDER_LESSONS,
		}
	},

	saveNotes(entityUID, presentationUID, notes, self_paceds, isLast) {
		return {
			type: t.BINDERS_SAVE_NOTES,
			entityUID,
			presentationUID,
			notes,
			self_paceds,
			isLast,
		}
	},

	cancelNotes() {
		return {
			type: t.BINDERS_CANCEL_NOTES,
		}
	},

	deleteLesson(entityUID, presentationUID, totalElements, order_field, order_type) {
		return {
			type: t.BINDERS_DELETE_LESSON,
			entityUID,
			presentationUID,
			page: totalElements - 1,
			order_field,
			order_type,
			limit: 1,
		}
	},

	confirmDeleteLesson(entityUID, presentationUID, totalElements, order_field, order_type) {
		return {
			type: t.OPEN_CONFIRM,
			confirmType: confirmTypes.BINDERS_LESSON_DELETE,
			confirmProps: {
				entityUID,
				presentationUID,
				totalElements,
				order_field,
				order_type,
			},

		}
	},

	deleteBinder(entityUID) {
		return {
			type: t.BINDERS_DELETE_BINDER,
			entityUID,
		}
	},

	confirmDeleteBinder(entityUID) {
		return {
			type: t.OPEN_CONFIRM,
			confirmType: confirmTypes.BINDERS_BINDER_DELETE,
			confirmProps: {
				entityUID,
			},
		}
	},

	setSort(order_field, order_type) {
		return {
			type: t.BINDERS_SET_BINDERS_SORT,
			payload: {
				order_field,
				order_type,
			},
		}
	},

	saveForm(values, resolve, reject) {
		return {
			values,
			type: t.BINDERS_SAVE_FORM,
			resolve,
			reject,
		}
	},

	shareForm(entityUID) {
		return {
			type: t.BINDERS_SHARE_FORM_FROM_LESSONS,
			entityUID,
		}
	},

	saveAndShareForm(values, resolve, reject, share) {
		return {
			values,
			type: t.BINDERS_SAVE_SHARE_FORM,
			resolve,
			reject,
			share,
		}
	},

	updateSort(order_field, order_type) {
		return {
			type: t.BINDERS_SORT_BINDERS,
			order_field,
			order_type,
		}
	},

	resetBinderData(entityUID) {
		return {
			type: t.BINDERS_RESET_BINDER_DATA,
			entityUID,
		}
	},

	createBinder(name) {
		return {
			type: t.BINDERS_BINDER_CREATE,
			name,
		}
	},

	cancelBinderCreation() {
		return {
			type: t.BINDERS_BINDER_CREATE_END,
			name,
		}
	},

	updateBinderText(value) {
		return {
			type: t.BINDERS_BINDER_CREATE_TEXT_UPDATE,
			value: value.target.value,
		}
	},

	resetNewBinderForm() {
		return {
			type: t.BINDERS_BINDER_CREATE_RESET,
		}
	},

	getBinderInformation(entityUID) {
		return {
			type: t.BINDERS_GET_BINDER_INFORMATION,
			entityUID,
		}
	},

	toggleFormBox(name) {
		return {
			type: t.BINDERS_TOGGLE_FORM_BOX,
			name,
		}
	},

	uploadDocument(values, resolve, reject) {
		return {
			type: t.BINDERS_UPLOAD_DOCUMENT,
			...values,
			resolve,
			reject,
		}
	},

	loadValidations(errors) {
		return {
			type: t.BINDERS_LOAD_VALIDATIONS,
			errors,
		}
	},

	searchLessons() {
		return {
			type: t.BINDERS_SEARCH_BINDER_LESSONS,
		}
	},

	initSearchLessons() {
		return {
			type: t.BINDERS_INIT_SEARCH_BINDER_LESSONS,
		}
	},

	saveLessons() {
		return {
			type: t.BINDERS_SAVE_LESSONS,
		}
	},

	selectLessons() {
		return {
			type: t.BINDERS_SELECT_LESSONS,
		}
	},

	lessonsPickerCancel() {
		return {
			type: t.BINDERS_PICKER_CANCEL,
		}
	},

	lessonsPickerClose() {
		return {
			type: t.BINDERS_PICKER_CANCEL,
		}
	},

	initializeBindersList() {
		return {
			type: t.BINDERS_INITIALIZE_LIST,
		}
	},

	goToOnboardingStep(step, time) {
		return {
			type: t.BINDERS_ONBOARDING_GO_TO_STEP,
			step,
			time,
		}
	},

	noSelfPaceds() {
		return {
			type: t.OPEN_TOP_INFORMATION,
			messageObject: {
				message: localize('binders_lessonNotes_missingLessons'),
				timeout: 3000,
				styleType: 'error',
			},
		}
	},

	lessonsCode(entityUID, presentationUID) {
		return {
			type: t.BINDERS_SHOW_LESSONS_CODE,
			presentationUID,
			entityUID,
		}
	},

	closeCodesModal() {
		return {
			type: t.BINDERS_CLOSE_CODES_MODAL,
		}
	},

	animationCompleted() {
		return {
			type: t.BINDERS_ONBOARDING_ANIMATION_COMPLETED,
		}
	},

	onboardingFailed() {
		return {
			type: t.BINDERS_ONBOARDING_FAILED,
		}
	},
}

export default binderActions
